<template>
  <section class="quotes-tab">
    <h3>Quotes</h3>
    <el-table
      :data="tableData"
      :header-row-class-name="'tableHeader'"
      style="width: 100%"
      @row-click="rowClick">
      <el-table-column
        width="60px"
        align="center">
        <template>
          <font-awesome-icon
            icon="dollar-sign" />
        </template>
      </el-table-column>
      <el-table-column
        label="Created"
        width="110px">
        <template #default="{ row }">
          <div class="flex-algin time-text">
            <span>{{ row.quote_dt.split(" ")[0] }}</span><br>
            <span> {{ row.quote_dt.split(" ")[1] }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Plan">
        <template #default="{row}">
          <div class="flex table-icon">
            <span class="span-options">{{row.type_language}}</span>
            <span
              v-tooltip="row.company_language"
              class="icon icon-content"
            >
              <img
                :src="getOptionData('companySmallIcon', row.company_id).logo? getOptionData('companySmallIcon', row.company_id).logo: row.company_logo"
              >
            </span>
            <span
              v-tooltip="row.class_language"
              class="icon icon-content"
            >
              <font-awesome-icon
                v-if="row.class_id"
                :icon="getOptionName('iconOptions', row.class_id)" />
            </span>
          </div>
          <router-link
            class="plan"
            :to="rowClickFn(row)">
            {{row.plan}}
          </router-link>
          <div class="quo">
            {{row.quotation_number}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Price">
        <template #default="{ row }">
          <div class="flex-algin">
            <span class="price">${{row.price}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="policy_period"
        label="Period"></el-table-column>
      <el-table-column
        label="Status">
        <template #default="{ row }">
          <div class="flex-algin">
            <div>
              <span
                class="span-status"
                :class="{
                  'yellow-dark': [4, 7].includes(row.stts),
                  'blue': [1, 5].includes(row.stts),
                  'red': [6].includes(row.stts),
                  'purple': [3].includes(row.stts)
                }">
                {{ row.stts_language }}
              </span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
export default {
  name: 'QuotesTab',
  mixins: [MixinOptions],
  props: {
    quoteData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tableData: [],
      pageConfig: {
        currentPage: 1,
        total: 10
      },
    }
  },
  watch: {
    quoteData:{
      immediate: true,
      handler(val){
        if(val){
          this.tableData = val.data
          this.pageConfig.currentPage = val.current_page
          this.pageConfig.total = val.total
        }
      }
    }
  },
  methods:{
    rowClick(row) {
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id: row.id,
          product_id: row.product_id
        }
      })
    },

    rowClickFn(row){
      return({
        path: '/records/quote/detail',
        query: {
          order_id: row.id,
          product_id: row.product_id
        }
      })
    },

    currentChange(page){
      this.pageConfig.currentPage = page
      this.$emit('currentChange', this.pageConfig.currentPage)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
     .cell{
       line-height: 23px;
       position: relative;
       height: inherit;
       padding: 0;
     }
    }
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;

  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    /* Text/text-gray-dark */
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    //line-height: 30px;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

  }
}
.quotes-tab{
  .flex-algin {
    &.time-text{
      font-weight: 400;
      font-size: 12px;
    }
  }
  .span-options {
    display: inline-block;
    padding: 0px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #24292E;
    height: 18px;
    background: #FFFFFF;
    border: 1px solid #6A737D;
    border-radius: 100px;
  }
  .table-icon{
    align-items: center;
    .icon{
      margin-left: 10px;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #e1e4e8;
    }
  }
  .plan{
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    color: #24292E;
    text-decoration: none;
    &:hover{
      color:  #0366D6;
    }
  }
  .quo{
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    color: #6A737D;
  }
  .price{
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    color: #24292E;
  }
  .span-status {
    display: inline-block;
    margin-right: 15px;
    padding: 5px 10px;
    border-radius: 12px;
    font-size: 12px;
    line-height: 14px;
    color: white;
    font-weight: 500;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
    &.green {
      background: #28a745;
      color: white;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
  }
}
</style>
